import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideCharts, withDefaultRegisterables} from 'ng2-charts';
import { APP_CONFIG } from './models/app-config';
import { ProfileService } from './profile.service';
import { loadingInterceptor } from './loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([loadingInterceptor])),
    provideCharts(withDefaultRegisterables()),
    provideAppInitializer(() => inject(ProfileService).load()),
    {
      provide: APP_CONFIG,
      useFactory: (profile: ProfileService) => ({ showAdvisories: profile.showAdvisories }),
      deps: [ProfileService]
    }
  ],
};
